import './FAQ.css';
export default {
    "view__wrapper": "FAQ_view__wrapper__19x0w",
    "question": "FAQ_question__19x0w",
    "answer": "FAQ_answer__19x0w"
};
